// extracted by mini-css-extract-plugin
export default {"button":"ExrOQi","hidden":"ag9AFl","mobile":"_VNI1t"};